import type { IAddTagCallingActionPayload } from 'entities/AICalling/api/types.ts'
import { addTag } from 'widgets/TemplateActions/addTag'
import { type AgentInstructionsStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/store/AgentInstructionsStore.tsx'
import { createAddTagCallingAction } from './createAddTagCallingAction.ts'

export const onAddTagChipClick =
  (store: AgentInstructionsStore) => (chip: HTMLSpanElement, data: { token_id: string }) => {
    const { getAgentAction, onUpdateAgentAction, deleteChipAndAgentAction } = store
    let action: IAddTagCallingActionPayload | undefined

    if ('token_id' in data) {
      const token_id = data.token_id
      const findAction = getAgentAction(token_id)

      if (token_id) {
        if (findAction?.action_type === 'add_tag') {
          action = findAction
        }
      }
    }
    if (action) {
      return addTag({
        onSave: (data) =>
          onUpdateAgentAction(createAddTagCallingAction(data, action.settings.token_id)),
        onDelete: () => deleteChipAndAgentAction(chip, action),
        data: action.settings,
      })
    }
  }
